import { Door } from 'graphql/generated/graphqlTypes';
import useDoorsAndLocations from 'hooks/useDoorsAndLocations/useDoorsAndLocations';
import useDrawer from 'hooks/useDrawer/useDrawer';
import useEnqueueSnackbar from 'hooks/useEnqueueSnackbar';
import useModal from 'hooks/useModal/useModal';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { sortBy } from 'lodash';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import DrawerTemplate from 'ui/organisms/Drawer/DrawerTemplate';
import ManageLockGroupsUI from 'ui/organisms/Drawer/variants/ManageLockGroups';
import { formKeyDownHandler } from 'utils/InputOnKeyDown/formKeyDownHandler.util';

const ManageLockGroups: React.FC<React.PropsWithChildren> = () => {
  const { translation } = useTranslation();
  const { handleSubmit } = useForm();
  const { hideDrawer } = useDrawer();
  const { showModal } = useModal();
  const [filterStr, setFilterStr] = useState('');
  const enqueueSnackbar = useEnqueueSnackbar();
  const handleFetchError = (errorMessage: string) => enqueueSnackbar(errorMessage, { snackbartype: 'error' });
  const { locationsWithDoors } = useDoorsAndLocations({
    handleFetchError
  });

  const getFilterData = () => {
    if (filterStr !== '')
      return locationsWithDoors.filter((location) =>
        (location.name.toLowerCase() + location.doors.length).includes(filterStr.toLowerCase())
      );
    return locationsWithDoors;
  };

  const onSubmit = async () => {
    hideDrawer();
  };

  const handleOpenCreateLockGroupModal = () => {
    showModal({ type: 'manageLockGroup', contentValue: { isEditing: false } });
    hideDrawer();
  };

  const handleOnDeleteLockGroupIconClick = (locationId: string) => {
    showModal({ type: 'deleteLockGroup', contentValue: { locationId } });
    hideDrawer();
  };

  const handleOpenEditLockGroupModal = (locationId: string, lockGroupName: string, selectedDoors: Door[]) => {
    showModal({
      type: 'manageLockGroup',
      contentValue: {
        isEditing: true,
        locationId,
        lockGroupName,
        selectedDoors
      }
    });
    hideDrawer();
  };

  return (
    <DrawerTemplate
      title={translation.manage_lock_groups}
      id="drawer-manage-lock-groups-lock"
      onSubmit={handleSubmit(onSubmit)}
      confirmButtonText={translation.close}
      closeButtonText={translation.cancel}
      closeButton={false}
    >
      <ManageLockGroupsUI
        handleOpenCreateLockGroupModal={handleOpenCreateLockGroupModal}
        handleOpenEditLockGroupModal={handleOpenEditLockGroupModal}
        inputOnKeyDown={(event) => formKeyDownHandler(event, onSubmit)}
        searchGroupInputValue={filterStr}
        searchGroupInputOnChange={setFilterStr}
        handleOnDeleteLockGroupIconClick={handleOnDeleteLockGroupIconClick}
        doorGroups={sortBy(getFilterData(), (data) => data.name)}
      />
    </DrawerTemplate>
  );
};
export default ManageLockGroups;
